import { render, staticRenderFns } from "./CustomProgress.vue?vue&type=template&id=22983d16&scoped=true"
import script from "./CustomProgress.vue?vue&type=script&lang=js"
export * from "./CustomProgress.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22983d16",
  null
  
)

export default component.exports